/**
 * @description 关于搜索 相关接口 http://api.umucdn.cn/project/329/interface/api/cat_209
 * @author liushuai
 */

import { API_TYPE } from '@umu/umu-fetch';
const BASE = '/uapi/v1';
const baseUrls = `${BASE}/search`;

export const SearchAPI = {
    // 搜索课程(学习项目、学习圈)接口
    SEARCH_COURSE: {
        url: `/uapi/v2/search/index`,// 接口升级，支持对学习圈和学习项目的搜索
        type: API_TYPE.GET,
    },
    // 搜索后点击行为统计接口
    STAT_SEARCH: {
        url: `${BASE}/stat/search`,
        type: API_TYPE.GET,
    },
    SEARCH_HISTORY: {
        url: `${baseUrls}/keyword-history-list`,
        type: API_TYPE.GET,
    },
    SEARCH_HISTORY_CLEAN: {
        url: `${baseUrls}/keyword-history-delete`,
        type: API_TYPE.POST,
    },
    SEARCH_RECOMMEND_COURSE: {
        url: `${baseUrls}/search-recommend-list`,
        type: API_TYPE.GET,
    },
    SEARCH_HOT_COURSE: {
        url: `${baseUrls}/hot-search-course-list`,
        type: API_TYPE.GET,
    },
    SEARCH_HISTORY_COURSE: {
        url: `${baseUrls}/course-latest-participate-list`,
        type: API_TYPE.GET,
    },
    SEARCH_ASSOCIATIVE_COURSE: {
        url: `${baseUrls}/search-sug-list`,
        type: API_TYPE.GET,
    },
};
